import { projectRequest } from 'store/utils/request';

export const getDictionaryEntriesRequest = async (dictionaryId, params) => {
  try {
    return await projectRequest.get(`/dictionaries/${dictionaryId}/entries/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addDictionaryEntryRequest = async (dictionaryId, data) => {
  try {
    return await projectRequest.post(
      `/dictionaries/${dictionaryId}/entries/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const updateDictionaryEntryRequest = async (dictionaryId, id, data) => {
  try {
    return await projectRequest.put(
      `/dictionaries/${dictionaryId}/entries/${id}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteDictionaryEntryRequest = async (dictionaryId, id) => {
  try {
    return await projectRequest.delete(
      `/dictionaries/${dictionaryId}/entries/${id}/`,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteDictionaryEntriesRequest = async (dictionaryId, ids) => {
  try {
    return await projectRequest.delete(
      `/dictionaries/${dictionaryId}/entries/delete/`,
      {
        data: {
          token_uuids: ids,
        },
      },
    );
  } catch (error) {
    throw error;
  }
};
